"use client";

/**
 * Error boundary du groupe de routes (global) — pages avec habillage complet
 * (chauffeur, location, excursions, faq, contact…). Client Component (Next).
 * Délègue l'UI au composant de marque partagé `ErrorView`.
 */

import { useEffect } from "react";
import { ErrorView } from "@/components/feedback/ErrorView";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}): JSX.Element {
  useEffect(() => {
    console.error(error);
  }, [error]);

  return <ErrorView reset={reset} />;
}
